import isFirstDayOfMonth from 'date-fns/isFirstDayOfMonth';
import isLastDayOfMonth from 'date-fns/isLastDayOfMonth';
import isSameDay from 'date-fns/isSameDay';
import isWithinInterval from 'date-fns/isWithinInterval';

const getSelectedStyle = (date, start, end) => {
    let className = 'selectedDay';
    if (isFirstDayOfMonth(date) || isSameDay(start, date)) {
        className += ' withLeftBorder leftRounded';
    }
    if (isLastDayOfMonth(date) || isSameDay(end, date)) {
        className += ' withRightBorder rightRounded';
    }
    return className;
};
const getHoveredClassName = (date, hoveredStart, hoveredEnd) => {
    let className = 'withinWeekRange';
    if (isFirstDayOfMonth(date) || isSameDay(hoveredStart, date)) {
        className = `${className} leftRounded`;
    }
    if (isLastDayOfMonth(date) || isSameDay(hoveredEnd, date)) {
        className = `${className} rightRounded`;
    }
    return className;
};
const getCustomRangeClassName = (date, selectedRange, hoveredDate, hoveredRange) => {
    var _a, _b;
    if (selectedRange) {
        const [start, end] = selectedRange;
        const isWithinSelectedRange = start && end && isWithinInterval(date, { start, end });
        if (isWithinSelectedRange) {
            return getSelectedStyle(date, start, end);
        }
    }
    if (hoveredDate) {
        const hoveredStart = (_a = hoveredRange === null || hoveredRange === void 0 ? void 0 : hoveredRange[0]) !== null && _a !== void 0 ? _a : hoveredDate;
        const hoveredEnd = (_b = hoveredRange === null || hoveredRange === void 0 ? void 0 : hoveredRange[1]) !== null && _b !== void 0 ? _b : hoveredDate;
        if (isWithinInterval(date, { start: hoveredStart, end: hoveredEnd })) {
            return getHoveredClassName(date, hoveredStart, hoveredEnd);
        }
    }
    if (isFirstDayOfMonth(date)) {
        return 'leftRounded';
    }
    if (isLastDayOfMonth(date)) {
        return 'rightRounded';
    }
    return null;
};

export { getCustomRangeClassName };
//# sourceMappingURL=getCustomRangeClassName.js.map
